import { title } from "assets/jss/material-kit-react.js";

const introductionStyle = {
  section: {
    padding: "60px 30px 70px",
    textAlign: "center",
    borderTop: '5px solid #72b545',
    borderRadius: 5
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: "#999"
  }
};

export default introductionStyle;
